import { render, staticRenderFns } from "./ChangePassForm.vue?vue&type=template&id=05ad7852&scoped=true&"
import script from "./ChangePassForm.vue?vue&type=script&lang=js&"
export * from "./ChangePassForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassForm.vue?vue&type=style&index=0&id=05ad7852&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ad7852",
  null
  
)

export default component.exports